// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__2-pAx","video-box":"Video_video-box__pSqtj","video-rate-control":"Video_video-rate-control__25qqF","video-close":"Video_video-close__14qzj"};